import { db } from '@/data/firebase/config';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  where,
} from 'firebase/firestore';

const SETTINGS_DOC = 'notificationSettings';

export interface NotificationSettings {
  testMode: boolean;
  devDocument: string;
}

/**
 * Por defecto DESHABILITADO. Solo el booleano true activa el modo prueba;
 * cualquier otro valor (ausente, false, o un truthy accidental) deja las
 * notificaciones yendo a todos los usuarios, que es el estado seguro.
 */
export function resolveNotificationSettings(
  data: Record<string, unknown> | undefined,
): NotificationSettings {
  return {
    testMode: data?.testMode === true,
    devDocument: typeof data?.devDocument === 'string' ? data.devDocument : '',
  };
}

export async function fetchNotificationSettings(): Promise<NotificationSettings> {
  try {
    const snap = await getDoc(doc(db, DOCUMENTS_DB.CONFIG, SETTINGS_DOC));
    return resolveNotificationSettings(snap.data());
  } catch (error) {
    console.error('Error leyendo notificationSettings:', error);
    return { testMode: false, devDocument: '' };
  }
}

export interface DevUserLookupResult {
  found: boolean;
  name?: string;
  hasPushToken?: boolean;
}

/** Busca un usuario por número de documento, para validar el devDocument antes de guardarlo. */
export async function findUserByDocument(
  documentNumber: string,
): Promise<DevUserLookupResult> {
  const snap = await getDocs(
    query(
      collection(db, DOCUMENTS_DB.USERS),
      where('document', '==', documentNumber),
      limit(1),
    ),
  );
  if (snap.empty) {
    return { found: false };
  }
  const data = snap.docs[0].data();
  return {
    found: true,
    name: `${data.name ?? ''} ${data.lastname ?? ''}`.trim(),
    hasPushToken:
      typeof data.expoPushToken === 'string' && data.expoPushToken.length > 0,
  };
}
